import { Button, Card, Form, Input, Message, Typography } from '@arco-design/web-react';
import { IconLock, IconUser } from '@arco-design/web-react/icon';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import type { LoginRequest } from '@/types/user';

export default function LoginView() {
  const navigate = useNavigate();
  const { login, loading } = useAuthStore();
  const [form] = Form.useForm<LoginRequest>();

  const onSubmit = async () => {
    try {
      const values = await form.validate();
      await login(values);
      Message.success('登录成功');
      navigate('/dashboard');
    } catch (e) {
      if (e instanceof Error) Message.error(e.message);
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background:
          'linear-gradient(135deg, #0f1f48 0%, #165DFF 100%)',
      }}
    >
      <Card
        style={{ width: 380, borderRadius: 16, boxShadow: '0 12px 32px rgba(0,0,0,0.18)' }}
      >
        <Typography.Title heading={4} style={{ marginTop: 0 }}>
          UP·CARD 控制台
        </Typography.Title>
        <Typography.Text type="secondary">
          虚拟卡台一站式资产管理 / 风控对账平台
        </Typography.Text>
        <Form form={form} layout="vertical" style={{ marginTop: 20 }} onSubmit={onSubmit}>
          <Form.Item field="username" rules={[{ required: true, message: '请输入登录账号' }]}>
            <Input prefix={<IconUser />} placeholder="登录账号" allowClear />
          </Form.Item>
          <Form.Item field="password" rules={[{ required: true, message: '请输入密码' }]}>
            <Input.Password prefix={<IconLock />} placeholder="登录密码" />
          </Form.Item>
          <Button type="primary" long loading={loading} onClick={onSubmit}>
            登录
          </Button>
        </Form>
      </Card>
    </div>
  );
}
